var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 210,
    viewBox: "0 0 260 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1512_8793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.838 150.8H136.848C135.168 150.8 133.801 149.432 133.801 147.752V10.8328C133.801 9.15295 135.168 7.78516 136.848 7.78516H230.838C232.518 7.78516 233.885 9.15295 233.885 10.8328V147.752C233.885 149.432 232.518 150.8 230.838 150.8ZM136.848 7.90997C135.241 7.90997 133.931 9.22056 133.931 10.8276V147.747C133.931 149.354 135.241 150.665 136.848 150.665H230.838C232.445 150.665 233.755 149.354 233.755 147.747V10.8328C233.755 9.22576 232.445 7.91517 230.838 7.91517H136.848V7.90997Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.454 150.8H28.4691C26.7895 150.8 25.4219 149.432 25.4219 147.752V10.8328C25.4219 9.15295 26.7895 7.78516 28.4691 7.78516H122.459C124.139 7.78516 125.506 9.15295 125.506 10.8328V147.752C125.506 149.432 124.139 150.8 122.459 150.8H122.454ZM28.4691 7.90997C26.8623 7.90997 25.5519 9.22056 25.5519 10.8276V147.747C25.5519 149.354 26.8623 150.665 28.4691 150.665H122.459C124.066 150.665 125.376 149.354 125.376 147.747V10.8328C125.376 9.22576 124.066 7.91517 122.459 7.91517H28.4691V7.90997Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 182.561H0V182.691H260V182.561Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9205 29.529C78.1457 30.7044 77.6309 31.9993 77.3501 33.3307L75.2285 33.5284V37.6369L77.3501 37.8345C77.6257 39.1659 78.1457 40.4609 78.9205 41.6363L77.5633 43.2745L80.4701 46.1817L82.1081 44.8243C83.2833 45.594 84.5781 46.1141 85.9093 46.3949L86.1069 48.5168H90.2149L90.4125 46.3949C91.7437 46.1193 93.0385 45.5992 94.2137 44.8243L95.8517 46.1817L98.7585 43.2745L97.4013 41.6363C98.1709 40.4609 98.6909 39.1659 98.9717 37.8345L101.093 37.6369V33.5284L98.9717 33.3307C98.6961 31.9993 98.1761 30.7044 97.4013 29.529L98.7585 27.8908L95.8517 24.9836L94.2137 26.341C93.0385 25.566 91.7437 25.0512 90.4125 24.7703L90.2149 22.6484H86.1069L85.9093 24.7703C84.5781 25.046 83.2833 25.566 82.1081 26.341L80.4701 24.9836L77.5633 27.8908L78.9205 29.529ZM92.0973 31.6509C94.2709 33.8248 94.2709 37.3457 92.0973 39.5196C89.9237 41.6935 86.4033 41.6935 84.2297 39.5196C82.0561 37.3457 82.0561 33.8248 84.2297 31.6509C86.4033 29.477 89.9237 29.477 92.0973 31.6509Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9954 84.4186L19.3906 87.6171C16.2914 88.0019 13.9358 84.8919 15.1526 82.0107L25.1834 58.233L35.2142 34.4553C36.431 31.5793 40.2998 31.0956 42.1874 33.5868L57.7614 54.166L73.3354 74.7453C75.2178 77.2364 73.7046 80.8353 70.6054 81.2202L45.0006 84.4186H44.9954Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5213 80.6489L20.6481 83.629C19.5925 83.759 18.7917 82.7032 19.2077 81.7255L28.5625 59.5548L37.8029 37.6598C38.2657 36.5572 39.7529 36.3752 40.4705 37.3269L54.8069 56.2731L69.3825 75.5366C69.9961 76.3531 69.5021 77.5285 68.4881 77.6533L44.5213 80.6489Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7305 53.6611L43.4765 52.9434L44.2825 67.1881L40.4501 67.6666L37.7305 53.6611ZM41.1157 74.6304C40.4813 74.1571 40.1173 73.5278 40.0185 72.7425C39.9197 71.9624 40.1173 71.2707 40.6061 70.6778C41.0949 70.0849 41.7761 69.7313 42.6393 69.6221C43.5025 69.5129 44.2461 69.6897 44.8701 70.1421C45.4941 70.5998 45.8529 71.2187 45.9517 71.9988C46.0505 72.7841 45.8477 73.481 45.3485 74.0999C44.8493 74.7188 44.1785 75.0776 43.3361 75.1869C42.4937 75.2909 41.7501 75.1088 41.1157 74.6304Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1367 123.912C22.1367 134.527 30.2123 143.134 40.1755 143.134H43.7219V104.695H40.1755C30.2123 104.695 22.1367 113.303 22.1367 123.917V123.912Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.727 143.133C54.3415 143.133 62.9462 134.527 62.9462 123.911C62.9462 113.295 54.3415 104.689 43.727 104.689C33.1125 104.689 24.5078 113.295 24.5078 123.911C24.5078 134.527 33.1125 143.133 43.727 143.133Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7266 139.299C52.2245 139.299 59.1134 132.409 59.1134 123.91C59.1134 115.411 52.2245 108.521 43.7266 108.521C35.2287 108.521 28.3398 115.411 28.3398 123.91C28.3398 132.409 35.2287 139.299 43.7266 139.299Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3325 112.204C39.8013 106.467 49.6917 107.066 55.4273 113.535C61.1629 120.005 60.5649 129.897 54.0961 135.633C59.3429 129.704 59.3429 120.795 54.0909 114.872C48.3553 108.402 38.4649 107.809 31.9961 113.54C32.4121 113.067 32.8593 112.625 33.3325 112.204Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4134 124.775C49.8674 124.219 49.0666 123.87 48.0058 123.725C48.5778 123.485 49.077 123.101 49.4566 122.612C49.9246 121.956 50.1326 121.15 50.0338 120.349C49.9558 119.377 49.4566 118.482 48.6662 117.905C47.855 117.297 46.7578 117.063 45.3746 117.203L44.5218 117.286L44.2826 114.873L42.6706 115.034L42.9098 117.447L40.913 117.645L40.6738 115.232L39.067 115.393L39.3062 117.806L35.8066 118.155L36.0978 121.062L37.3562 120.937L38.209 129.477L36.9506 129.601L37.2418 132.509L40.7414 132.16L40.9806 134.573L42.5874 134.412L42.3482 131.999L44.345 131.801L44.5842 134.215L46.1962 134.053L45.957 131.64L46.1598 131.619C46.8202 131.521 47.4806 131.391 48.1306 131.224C48.8742 131.052 49.4202 130.839 49.7686 130.584C50.325 130.189 50.767 129.653 51.0478 129.035C51.3338 128.39 51.443 127.677 51.3598 126.975C51.2766 126.06 50.9594 125.326 50.4082 124.77L50.4134 124.775ZM41.8386 120.495L43.799 120.297C44.4698 120.23 44.9534 120.297 45.2498 120.511C45.5514 120.729 45.7386 121.078 45.7542 121.452C45.8166 121.837 45.7074 122.232 45.4526 122.529C45.2082 122.794 44.735 122.96 44.0434 123.033L42.1142 123.225L41.8438 120.5L41.8386 120.495ZM46.5134 128.072C46.2274 128.374 45.7022 128.567 44.9378 128.639L42.6758 128.863L42.3846 125.945L44.6362 125.722C45.4162 125.644 45.9726 125.722 46.3054 125.945C46.6382 126.164 46.8462 126.523 46.8722 126.918C46.9346 127.339 46.8046 127.76 46.5134 128.067V128.072Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8731 124.826C49.3271 124.27 48.5263 123.921 47.4655 123.775C48.0375 123.536 48.5419 123.151 48.9163 122.663C49.3843 122.007 49.5871 121.201 49.4935 120.4C49.4155 119.428 48.9163 118.533 48.1259 117.956C47.3147 117.347 46.2175 117.113 44.8343 117.254L43.9815 117.337L43.7423 114.924L42.1355 115.085L42.3747 117.498L40.3779 117.696L40.1387 115.283L38.5319 115.444L38.7711 117.857L35.2715 118.205L35.5627 121.113L36.8211 120.988L37.6739 129.527L36.4155 129.652L36.7067 132.559L40.2063 132.211L40.4455 134.624L42.0523 134.463L41.8131 132.05L43.8099 131.852L44.0491 134.265L45.6559 134.104L45.4167 131.691L45.6195 131.67C46.2799 131.571 46.9403 131.441 47.5903 131.275C48.3287 131.103 48.8747 130.89 49.2283 130.635C49.7847 130.24 50.2267 129.704 50.5075 129.085C50.7935 128.441 50.9027 127.728 50.8195 127.026C50.7363 126.111 50.4191 125.377 49.8679 124.821L49.8731 124.826ZM41.2983 120.546L43.2587 120.348C43.9295 120.281 44.4131 120.348 44.7095 120.561C45.0111 120.78 45.1983 121.128 45.2139 121.503C45.2763 121.888 45.1671 122.283 44.9123 122.579C44.6627 122.845 44.1947 123.011 43.5031 123.084L41.5739 123.276L41.3035 120.551L41.2983 120.546ZM45.9731 128.123C45.6871 128.425 45.1619 128.617 44.3975 128.69L42.1355 128.914L41.8443 125.996L44.0959 125.773C44.8707 125.695 45.4271 125.773 45.7651 125.996C46.0979 126.215 46.3059 126.573 46.3319 126.969C46.3943 127.39 46.2643 127.811 45.9731 128.118V128.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.421 32.1555C138.071 42.3229 143.9 52.3551 153.442 54.5654L156.837 55.3507L165.355 18.5296L161.959 17.7443C152.417 15.534 142.771 21.9881 140.421 32.1555Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.935 55.8267C172.358 55.3607 180.43 46.532 179.964 36.1074C179.498 25.6829 170.671 17.6099 160.248 18.076C149.825 18.5421 141.753 27.3707 142.219 37.7953C142.685 48.2199 151.512 56.2928 161.935 55.8267Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.796 47.6411C177.703 41.7329 177.703 32.1538 171.796 26.2456C165.888 20.3374 156.311 20.3374 150.403 26.2456C144.496 32.1538 144.496 41.7329 150.403 47.6411C156.311 53.5493 165.888 53.5493 171.796 47.6411Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.738 23.4232C161.206 19.3614 170.55 22.1282 174.606 29.5913C178.662 37.0543 175.901 46.4052 168.439 50.4618C174.778 45.9475 176.754 37.408 173.036 30.5742C168.974 23.106 159.63 20.3444 152.168 24.4061C152.672 24.0473 153.198 23.7196 153.744 23.4232H153.738Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.314 39.2488C166.914 38.5935 166.222 38.0838 165.245 37.7094C165.848 37.6106 166.41 37.3505 166.883 36.9657C167.476 36.4404 167.855 35.7123 167.938 34.927C168.079 33.9753 167.798 33.0131 167.169 32.285C166.529 31.5257 165.531 31.0577 164.174 30.8808L163.342 30.7716L163.643 28.4053L162.068 28.2025L161.766 30.5688L159.811 30.3192L160.112 27.9528L158.537 27.75L158.235 30.1163L154.808 29.6743L154.444 32.5243L155.677 32.6803L154.6 41.0482L153.368 40.8922L153.004 43.7422L156.431 44.1843L156.129 46.5506L157.705 46.7534L158.006 44.3871L159.962 44.6367L159.66 47.0031L161.236 47.2059L161.537 44.8396L161.735 44.8656C162.39 44.9176 163.05 44.9384 163.706 44.9228C164.454 44.9228 165.026 44.8396 165.416 44.6732C166.035 44.4183 166.576 44.0023 166.987 43.4718C167.403 42.9153 167.663 42.26 167.741 41.5683C167.86 40.6738 167.72 39.8989 167.32 39.2436L167.314 39.2488ZM160.05 33.2472L161.969 33.4916C162.629 33.5748 163.076 33.7516 163.31 34.0169C163.55 34.2977 163.654 34.667 163.586 35.031C163.56 35.4159 163.368 35.7643 163.056 35.9931C162.759 36.1908 162.276 36.248 161.594 36.1596L159.707 35.9151L160.05 33.2472ZM162.848 41.5423C162.504 41.7711 161.964 41.8336 161.215 41.7399L159 41.4539L159.369 38.5935L161.574 38.8795C162.338 38.9784 162.853 39.1708 163.123 39.462C163.394 39.7429 163.513 40.1381 163.451 40.523C163.42 40.939 163.196 41.3135 162.848 41.5423Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.784 39.1824C166.383 38.5271 165.692 38.0174 164.714 37.643C165.317 37.539 165.879 37.2841 166.352 36.8993C166.945 36.374 167.319 35.6459 167.402 34.8606C167.543 33.9089 167.262 32.9467 166.633 32.2186C165.993 31.4593 164.995 30.9913 163.638 30.8144L162.806 30.7052L163.107 28.3389L161.532 28.1361L161.23 30.5024L159.27 30.2528L159.571 27.8864L157.996 27.6836L157.694 30.0499L154.267 29.6079L153.903 32.4579L155.136 32.6139L154.059 40.9818L152.827 40.8258L152.463 43.6758L155.89 44.1179L155.588 46.4842L157.164 46.687L157.465 44.3207L159.426 44.5703L159.124 46.9367L160.7 47.1395L161.001 44.7732L161.199 44.7992C161.854 44.8512 162.514 44.872 163.17 44.8564C163.918 44.8564 164.485 44.7732 164.88 44.6067C165.499 44.3519 166.04 43.9359 166.451 43.4054C166.867 42.8489 167.127 42.1936 167.205 41.5019C167.324 40.6074 167.184 39.8325 166.784 39.1772V39.1824ZM159.519 33.1808L161.438 33.4252C162.098 33.5084 162.546 33.6852 162.78 33.9505C163.019 34.2313 163.123 34.6006 163.055 34.9646C163.029 35.3495 162.837 35.6979 162.525 35.9267C162.228 36.1244 161.74 36.1816 161.064 36.0932L159.176 35.8487L159.519 33.1808ZM162.317 41.4759C161.974 41.7047 161.433 41.7671 160.684 41.6735L158.469 41.3875L158.838 38.5271L161.043 38.8131C161.802 38.912 162.322 39.1044 162.592 39.3956C162.863 39.6765 162.982 40.0717 162.92 40.4566C162.889 40.8726 162.665 41.2471 162.317 41.4759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.463 15.9821C112.643 23.3827 119.237 28.4846 126.184 27.3769L128.659 26.9816L124.375 0.171875L121.899 0.56713C114.952 1.68008 110.277 8.57624 111.458 15.9821H111.463Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.204 27.044C135.642 26.1109 140.915 19.3245 139.982 11.8862C139.049 4.44784 132.263 -0.825721 124.826 0.107368C117.389 1.04046 112.116 7.82685 113.049 15.2652C113.982 22.7036 120.767 27.9771 128.204 27.044Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.965 23.4876C136.441 21.0307 138.889 14.5987 136.433 9.12149C133.976 3.64425 127.545 1.19585 122.068 3.65282C116.592 6.10979 114.144 12.5417 116.6 18.019C119.057 23.4962 125.488 25.9446 130.965 23.4876Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.969 6.56798C121.843 1.84572 128.806 1.15923 133.527 5.03377C138.249 8.90831 138.935 15.8721 135.061 20.5943C138.062 15.8773 137.068 9.66241 132.742 6.11552C128.02 2.24098 121.058 2.93268 117.184 7.64973C117.423 7.27528 117.683 6.91123 117.964 6.56798H117.969Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.281 13.4271C130.839 13.0995 130.241 12.9486 129.487 12.9642C129.861 12.7354 130.168 12.413 130.376 12.0229C130.631 11.5132 130.683 10.9255 130.527 10.3795C130.365 9.70858 129.918 9.1417 129.299 8.82966C128.665 8.49681 127.875 8.4552 126.928 8.70484L126.346 8.86086L125.909 7.20703L124.807 7.49827L125.243 9.1521L123.876 9.51615L123.439 7.86232L122.337 8.15356L122.773 9.80739L120.371 10.4419L120.896 12.439L121.759 12.2101L123.304 18.0713L122.441 18.3002L122.966 20.2972L125.368 19.6628L125.805 21.3166L126.907 21.0254L126.471 19.3715L127.838 19.0075L128.275 20.6613L129.377 20.3701L128.941 18.7162L129.081 18.6798C129.533 18.5394 129.975 18.373 130.412 18.1858C130.911 17.9829 131.265 17.7749 131.483 17.5565C131.827 17.2184 132.076 16.7972 132.201 16.3343C132.326 15.8506 132.326 15.3462 132.185 14.8625C132.024 14.2332 131.723 13.7547 131.275 13.4323L131.281 13.4271ZM124.827 11.3936L126.174 11.04C126.637 10.9203 126.98 10.9151 127.209 11.0244C127.443 11.144 127.609 11.3676 127.667 11.6224C127.755 11.8825 127.719 12.1685 127.573 12.4078C127.433 12.621 127.121 12.7874 126.647 12.9122L125.327 13.2607L124.833 11.3936H124.827ZM128.93 16.1575C128.764 16.4019 128.421 16.5891 127.895 16.7296L126.341 17.1404L125.81 15.1381L127.355 14.7325C127.89 14.5921 128.285 14.5817 128.545 14.7013C128.8 14.8157 128.987 15.0445 129.05 15.3202C129.143 15.6062 129.097 15.9182 128.925 16.1627L128.93 16.1575Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.911 13.5267C130.469 13.1991 129.871 13.043 129.117 13.0638C129.491 12.835 129.798 12.5074 130.006 12.1225C130.261 11.6128 130.313 11.0252 130.157 10.4791C129.996 9.80819 129.548 9.24131 128.93 8.92927C128.295 8.59642 127.505 8.55481 126.558 8.80445L125.976 8.96047L125.539 7.30664L124.437 7.59788L124.874 9.25171L123.501 9.61576L123.064 7.96193L121.962 8.25317L122.398 9.907L119.996 10.5415L120.521 12.5386L121.384 12.3097L122.929 18.1709L122.066 18.3998L122.591 20.3969L124.993 19.7624L125.43 21.4162L126.532 21.125L126.096 19.4711L127.468 19.1071L127.905 20.7609L129.008 20.4697L128.571 18.8158L128.711 18.7794C129.164 18.639 129.606 18.4726 130.042 18.2854C130.542 18.0825 130.895 17.8745 131.114 17.6561C131.457 17.318 131.707 16.8968 131.831 16.4339C131.956 15.9502 131.956 15.4458 131.816 14.9621C131.655 14.3328 131.353 13.8544 130.906 13.5319L130.911 13.5267ZM124.458 11.4932L125.804 11.1396C126.267 11.02 126.61 11.0148 126.839 11.124C127.073 11.2436 127.24 11.4672 127.297 11.7221C127.385 11.9821 127.349 12.2681 127.203 12.5074C127.063 12.7206 126.751 12.887 126.278 13.017L124.952 13.3655L124.458 11.4984V11.4932ZM128.56 16.2571C128.394 16.5015 128.051 16.6887 127.526 16.8292L125.971 17.24L125.44 15.2377L126.985 14.8321C127.52 14.6917 127.916 14.6813 128.176 14.8009C128.431 14.9153 128.618 15.1441 128.68 15.4198C128.774 15.7058 128.727 16.0179 128.555 16.2623L128.56 16.2571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.909 43.8418H216.227V50.5923H235.909V43.8418Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.578 44.1598V58.4306C214.578 58.8258 214.901 59.1483 215.296 59.1483H236.299C236.694 59.1483 237.016 58.8258 237.016 58.4306V45.564C237.016 45.1688 236.694 44.8463 236.299 44.8463H223.527C223.267 44.8463 223.028 44.7059 222.903 44.4823L222.503 43.775C222.399 43.5929 222.201 43.4785 221.988 43.4785H215.28C214.895 43.4785 214.583 43.7802 214.583 44.1598H214.578Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.921 159.188L63.9902 159.277V161.076L64.921 161.165C65.0406 161.747 65.2694 162.314 65.6074 162.829L65.0146 163.547L66.2886 164.821L67.0062 164.228C67.521 164.566 68.0878 164.795 68.6702 164.914L68.7586 165.845H70.5578L70.6462 164.914C71.2286 164.795 71.7954 164.566 72.3102 164.228L73.0278 164.821L74.3018 163.547L73.709 162.829C74.047 162.314 74.2758 161.747 74.3954 161.165L75.3262 161.076V159.277L74.3954 159.188C74.2758 158.606 74.047 158.039 73.709 157.524L74.3018 156.807L73.0278 155.532L72.3102 156.125C71.7954 155.787 71.2286 155.558 70.6462 155.439L70.5578 154.508H68.7586L68.6702 155.439C68.0878 155.558 67.521 155.787 67.0062 156.125L66.2886 155.532L65.0146 156.807L65.6074 157.524C65.2694 158.039 65.0406 158.606 64.921 159.188ZM71.3794 158.455C72.331 159.407 72.331 160.952 71.3794 161.903C70.4278 162.855 68.8834 162.855 67.9318 161.903C66.9802 160.952 66.9802 159.407 67.9318 158.455C68.8834 157.503 70.4278 157.503 71.3794 158.455Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9137 18.2384L62.8633 18.3372V20.3759L63.9137 20.4747C64.0489 21.1352 64.3089 21.7748 64.6885 22.3573L64.0177 23.1686L65.4581 24.6092L66.2693 23.9383C66.8517 24.3232 67.4913 24.578 68.1517 24.7133L68.2505 25.7638H70.2889L70.3877 24.7133C71.0481 24.578 71.6877 24.318 72.2701 23.9383L73.0813 24.6092L74.5217 23.1686L73.8509 22.3573C74.2357 21.7748 74.4905 21.1352 74.6257 20.4747L75.6761 20.3759V18.3372L74.6257 18.2384C74.4905 17.5779 74.2305 16.9382 73.8509 16.3557L74.5217 15.5444L73.0813 14.1038L72.2701 14.7747C71.6877 14.3898 71.0481 14.135 70.3877 13.9998L70.2889 12.9492H68.2505L68.1517 13.9998C67.4913 14.135 66.8517 14.395 66.2693 14.7747L65.4581 14.1038L64.0177 15.5444L64.6885 16.3557C64.3037 16.9382 64.0489 17.5779 63.9137 18.2384ZM71.2197 17.4062C72.2961 18.4828 72.2961 20.2302 71.2197 21.3068C70.1433 22.3833 68.3961 22.3833 67.3197 21.3068C66.2433 20.2302 66.2433 18.4828 67.3197 17.4062C68.3961 16.3297 70.1433 16.3297 71.2197 17.4062Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.755 18.2805C194.199 19.1282 193.825 20.0643 193.622 21.0265L192.088 21.1721V24.1417L193.622 24.2873C193.819 25.2495 194.199 26.1804 194.755 27.0333L193.778 28.2139L195.879 30.315L197.059 29.3372C197.907 29.8937 198.843 30.2682 199.805 30.471L199.95 32.0052H202.919L203.065 30.471C204.027 30.2734 204.958 29.8937 205.811 29.3372L206.991 30.315L209.092 28.2139L208.114 27.0333C208.671 26.1856 209.045 25.2495 209.248 24.2873L210.782 24.1417V21.1721L209.248 21.0265C209.05 20.0643 208.671 19.1334 208.114 18.2805L209.092 17.0999L206.991 14.9988L205.811 15.9766C204.963 15.4201 204.027 15.0456 203.065 14.8428L202.919 13.3086H199.95L199.805 14.8428C198.843 15.0404 197.912 15.4201 197.059 15.9766L195.879 14.9988L193.778 17.0999L194.755 18.2805ZM204.271 19.8147C205.842 21.3853 205.842 23.9285 204.271 25.4991C202.701 27.0697 200.158 27.0697 198.588 25.4991C197.017 23.9285 197.017 21.3853 198.588 19.8147C200.158 18.2441 202.701 18.2441 204.271 19.8147Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.568 93.9817C230.012 94.8294 229.637 95.7655 229.434 96.7276L227.9 96.8733V99.8429L229.434 99.9885C229.632 100.951 230.012 101.882 230.568 102.734L229.59 103.915L231.691 106.016L232.872 105.038C233.719 105.595 234.655 105.969 235.617 106.172L235.763 107.706H238.732L238.878 106.172C239.84 105.975 240.77 105.595 241.623 105.038L242.804 106.016L244.904 103.915L243.927 102.734C244.483 101.887 244.858 100.951 245.06 99.9885L246.594 99.8429V96.8733L245.06 96.7276C244.863 95.7655 244.483 94.8346 243.927 93.9817L244.904 92.8011L242.804 90.7L241.623 91.6777C240.776 91.1213 239.84 90.7468 238.878 90.544L238.732 89.0098H235.763L235.617 90.544C234.655 90.7416 233.724 91.1213 232.872 91.6777L231.691 90.7L229.59 92.8011L230.568 93.9817ZM240.084 95.5159C241.654 97.0865 241.654 99.6296 240.084 101.2C238.514 102.771 235.971 102.771 234.4 101.2C232.83 99.6296 232.83 97.0865 234.4 95.5159C235.971 93.9453 238.514 93.9453 240.084 95.5159Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.457 206.811C241.457 208.574 192.827 209.999 132.845 209.999C72.8628 209.999 24.2324 208.569 24.2324 206.811C24.2324 205.053 72.8628 203.623 132.845 203.623C192.827 203.623 241.457 205.053 241.457 206.811Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.307 88.8643C226.878 88.8643 231.395 84.3472 231.395 78.7749C231.395 73.2027 226.878 68.6855 221.307 68.6855C215.735 68.6855 211.219 73.2027 211.219 78.7749C211.219 84.3472 215.735 88.8643 221.307 88.8643Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.788 86.5352L217.619 87.9602L218.779 91.0234L221.155 88.8443L219.788 86.5352Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.385 86.6992L220.013 81.2152H222.245L221.873 86.6992H220.385ZM221.129 89.7112C220.457 89.7112 219.977 89.2192 219.977 88.6192C219.977 88.0072 220.457 87.5512 221.129 87.5512C221.801 87.5512 222.281 88.0072 222.281 88.6192C222.281 89.2192 221.801 89.7112 221.129 89.7112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.141 68.9863C230.073 70.4529 232.169 73.4798 232.512 76.7406",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.616 78.2441C232.704 78.7382 232.689 79.2479 232.574 79.7315",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.751 180.002V182.093C149.751 182.353 149.537 182.561 149.277 182.561H90.2575C88.0735 182.561 86.5863 180.356 87.4027 178.338L106.107 132.01L136.329 132.218L135.3 138.23L128.633 177.136C128.415 178.39 129.382 179.544 130.656 179.544H149.277C149.537 179.544 149.751 179.752 149.751 180.012V180.002Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.751 180.002V182.093C149.751 182.353 149.537 182.561 149.277 182.561H90.2575C88.0735 182.561 86.5863 180.356 87.4027 178.338L98.9987 149.619L106.107 132.01L136.329 132.218L135.3 138.23L132.398 155.148L128.628 177.131C128.41 178.385 129.377 179.539 130.651 179.539H149.272C149.532 179.539 149.745 179.747 149.745 180.007L149.751 180.002Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.656 179.539H92.254C91.292 179.539 90.642 178.561 91.0112 177.672L107.407 138.225H135.294L128.628 177.131C128.41 178.385 129.377 179.539 130.651 179.539H130.656Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.329 132.218L135.294 138.225L132.398 155.148L98.998 149.619L106.101 132.01L136.329 132.218Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.099 45.8548H55.1726C53.1966 45.8548 51.5898 47.4566 51.5898 49.4381V144.18C51.5898 146.156 53.1914 147.763 55.1726 147.763H195.099C197.075 147.763 198.682 146.161 198.682 144.18V49.4329C198.682 47.4566 197.081 45.8496 195.099 45.8496V45.8548Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.099 45.8548H55.1726C53.1966 45.8548 51.5898 47.4566 51.5898 49.4381V144.18C51.5898 146.156 53.1914 147.763 55.1726 147.763H195.099C197.075 147.763 198.682 146.161 198.682 144.18V49.4329C198.682 47.4566 197.081 45.8496 195.099 45.8496V45.8548Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1373 147.758H55.1733C53.1973 147.758 51.5957 146.157 51.5957 144.18V49.4388C51.5957 47.4573 53.1973 45.8555 55.1733 45.8555H58.1373C56.1613 45.8555 54.5597 47.4573 54.5597 49.4388V144.18C54.5597 146.157 56.1613 147.758 58.1373 147.758Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.454 48.9277H57.7891V140.284H195.454V48.9277Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.454 48.9277H57.7891V140.284H195.454V48.9277Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.511 48.9277H57.6797V140.393H195.511V48.9277Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.511 48.9277H57.6797V140.393H195.511V48.9277Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.511 48.9277H57.6797V57.8002H195.511V48.9277Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.895 53.3649C192.895 54.2282 192.199 54.9251 191.335 54.9251C190.472 54.9251 189.775 54.2282 189.775 53.3649C189.775 52.5016 190.472 51.8047 191.335 51.8047C192.199 51.8047 192.895 52.5016 192.895 53.3649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.466 53.3649C188.466 54.2282 187.769 54.9251 186.906 54.9251C186.043 54.9251 185.346 54.2282 185.346 53.3649C185.346 52.5016 186.043 51.8047 186.906 51.8047C187.769 51.8047 188.466 52.5016 188.466 53.3649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.03 53.3649C184.03 54.2282 183.333 54.9251 182.47 54.9251C181.607 54.9251 180.91 54.2282 180.91 53.3649C180.91 52.5016 181.607 51.8047 182.47 51.8047C183.333 51.8047 184.03 52.5016 184.03 53.3649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.512 57.8008H193.557V140.378H195.512V57.8008Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.512 57.8008H193.557V76.5234H195.512V57.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.734 67.2812H168.945V72.352H183.734V67.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.707 67.5149V78.2388C167.707 78.5352 167.946 78.7796 168.248 78.7796H184.025C184.321 78.7796 184.565 78.5404 184.565 78.2388V68.5706C184.565 68.2742 184.326 68.0297 184.025 68.0297H174.431C174.238 68.0297 174.056 67.9257 173.963 67.7541L173.661 67.2236C173.583 67.0884 173.437 67 173.276 67H168.237C167.946 67 167.712 67.2288 167.712 67.5097L167.707 67.5149Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.734 87.9805H168.945V93.0512H183.734V87.9805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.707 88.22V98.9438C167.707 99.2403 167.946 99.4847 168.248 99.4847H184.025C184.321 99.4847 184.565 99.2455 184.565 98.9438V89.2757C184.565 88.9793 184.326 88.7348 184.025 88.7348H174.431C174.238 88.7348 174.056 88.6308 173.963 88.4592L173.661 87.9287C173.583 87.7935 173.437 87.7051 173.276 87.7051H168.237C167.946 87.7051 167.712 87.9339 167.712 88.2147L167.707 88.22Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.734 106.775H168.945V111.846H183.734V106.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.707 107.015V117.739C167.707 118.035 167.946 118.28 168.248 118.28H184.025C184.321 118.28 184.565 118.04 184.565 117.739V108.071C184.565 107.774 184.326 107.53 184.025 107.53H174.431C174.238 107.53 174.056 107.426 173.963 107.254L173.661 106.724C173.583 106.588 173.437 106.5 173.276 106.5H168.237C167.946 106.5 167.712 106.729 167.712 107.01L167.707 107.015Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3122 67.2812H64.5234V72.352H79.3122V67.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2852 67.5149V78.2388C63.2852 78.5352 63.5244 78.7796 63.826 78.7796H79.6028C79.8992 78.7796 80.1436 78.5404 80.1436 78.2388V68.5706C80.1436 68.2742 79.9044 68.0297 79.6028 68.0297H70.0088C69.8164 68.0297 69.6344 67.9257 69.5408 67.7541L69.2392 67.2236C69.1612 67.0884 69.0156 67 68.8544 67H63.8156C63.5244 67 63.2904 67.2288 63.2904 67.5097L63.2852 67.5149Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3122 89.2598H64.5234V94.3305H79.3122V89.2598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2852 89.4934V100.217C63.2852 100.514 63.5244 100.758 63.826 100.758H79.6028C79.8992 100.758 80.1436 100.519 80.1436 100.217V90.5491C80.1436 90.2527 79.9044 90.0083 79.6028 90.0083H70.0088C69.8164 90.0083 69.6344 89.9042 69.5408 89.7326L69.2392 89.2022C69.1612 89.0669 69.0156 88.9785 68.8544 88.9785H63.8156C63.5244 88.9785 63.2904 89.2074 63.2904 89.4882L63.2852 89.4934Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3122 109.355H64.5234V114.426H79.3122V109.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2852 109.589V120.313C63.2852 120.609 63.5244 120.854 63.826 120.854H79.6028C79.8992 120.854 80.1436 120.615 80.1436 120.313V110.645C80.1436 110.348 79.9044 110.104 79.6028 110.104H70.0088C69.8164 110.104 69.6344 110 69.5408 109.828L69.2392 109.298C69.1612 109.163 69.0156 109.074 68.8544 109.074H63.8156C63.5244 109.074 63.2904 109.303 63.2904 109.584L63.2852 109.589Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.194 66.7812H95.791V88.0262H156.194V66.7812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7363 67.7755V112.705C90.7363 113.953 91.7243 114.967 92.9411 114.967H157.4C158.617 114.967 159.605 113.953 159.605 112.705V72.1961C159.605 70.948 158.617 69.9338 157.4 69.9338H118.198C117.407 69.9338 116.674 69.497 116.284 68.7897L115.052 66.5637C114.734 65.9917 114.131 65.6328 113.476 65.6328H92.8839C91.7035 65.6328 90.7415 66.5897 90.7415 67.7703L90.7363 67.7755Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4319 85.0835C88.2863 85.0835 88.1719 84.9691 88.1719 84.8234V71.1975C88.1719 71.0519 88.2863 70.9375 88.4319 70.9375C88.5775 70.9375 88.6919 71.0519 88.6919 71.1975V84.8234C88.6919 84.9691 88.5775 85.0835 88.4319 85.0835Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4319 69.6686C88.2863 69.6686 88.1719 69.5542 88.1719 69.4086V67.7132C88.1719 67.5675 88.2863 67.4531 88.4319 67.4531C88.5775 67.4531 88.6919 67.5675 88.6919 67.7132V69.4086C88.6919 69.5542 88.5775 69.6686 88.4319 69.6686Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.335 102.962H116.908V96.8463C116.908 91.4115 121.266 86.9961 126.622 86.9961C131.978 86.9961 136.335 91.4167 136.335 96.8463V102.962ZM119.071 100.768H134.172V96.8463C134.172 92.6233 130.787 89.1856 126.622 89.1856C122.457 89.1856 119.071 92.6233 119.071 96.8463V100.768Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.814 100.426H116.42C114.964 100.426 113.783 101.606 113.783 103.063V118.503C113.783 119.96 114.964 121.14 116.42 121.14H136.814C138.27 121.14 139.45 119.96 139.45 118.503V103.063C139.45 101.606 138.27 100.426 136.814 100.426Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.814 100.426H116.42C114.964 100.426 113.783 101.606 113.783 103.063V116.096C113.783 117.552 114.964 118.732 116.42 118.732H136.814C138.27 118.732 139.45 117.552 139.45 116.096V103.063C139.45 101.606 138.27 100.426 136.814 100.426Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.553 107.966C129.553 109.672 128.191 111.055 126.506 111.055C124.821 111.055 123.459 109.672 123.459 107.966C123.459 106.26 124.821 104.877 126.506 104.877C128.191 104.877 129.553 106.26 129.553 107.966Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.893 108.893L124.666 114.28H128.847L127.198 108.861L125.893 108.893Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6 98.3552C146.797 98.3552 144.255 96.4101 143.584 93.5237C143.204 91.8907 143.475 90.2109 144.338 88.7859C145.206 87.3609 146.569 86.3623 148.175 85.9775L154.863 84.3757C156.469 83.9908 158.128 84.2612 159.537 85.1454C160.941 86.0243 161.924 87.4077 162.309 89.0407C163.094 92.4056 161.03 95.7913 157.712 96.587L151.025 98.1888C150.547 98.3032 150.073 98.3552 149.6 98.3552ZM156.287 86.7628C156.012 86.7628 155.726 86.794 155.445 86.8616L148.758 88.4634C146.792 88.9367 145.575 90.939 146.038 92.9309C146.501 94.9227 148.477 96.1605 150.443 95.6872L157.13 94.0854C159.095 93.6121 160.312 91.6099 159.849 89.618C159.454 87.9122 157.946 86.7576 156.287 86.7576V86.7628Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.836 95.5256C132.217 95.5256 131.671 95.0627 131.588 94.4178C131.494 93.7157 131.978 93.0708 132.669 92.9772L147.531 90.9177C148.223 90.8241 148.857 91.313 148.951 92.0099C149.044 92.712 148.561 93.3569 147.869 93.4505L133.007 95.51C132.95 95.5204 132.893 95.5204 132.836 95.5204V95.5256Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.095 92.915L135.378 92.603L135.201 92.2441L132.949 92.681L133.095 92.915Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.027 95.3752L136.18 95.0684L136.243 95.4948L134.095 95.7497L134.027 95.3752Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.709 94.0379L146.288 93.6738L146.481 94.0379L143.886 94.4955L143.709 94.0379Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.434 91.443L146.08 91.1102L146.174 90.7773L143.486 91.0582L143.434 91.443Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.828 91.7869C173.031 91.9326 170.389 90.1227 169.573 87.2779C169.11 85.6709 169.292 83.9754 170.088 82.5036C170.883 81.037 172.194 79.9657 173.78 79.4976L180.373 77.5474C181.959 77.0793 183.628 77.2665 185.079 78.0726C186.53 78.8787 187.58 80.2101 188.043 81.8172C188.995 85.1404 187.112 88.6249 183.836 89.5974L177.243 91.5477C176.775 91.6881 176.296 91.7661 175.828 91.7921V91.7869ZM181.918 79.8617C181.642 79.8773 181.361 79.9241 181.08 80.0073L174.487 81.9576C172.547 82.5296 171.429 84.5943 171.996 86.5602C172.563 88.5261 174.596 89.6598 176.536 89.0878L183.129 87.1375C185.069 86.5654 186.187 84.5007 185.62 82.5348C185.136 80.8498 183.571 79.7785 181.918 79.8669V79.8617Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.939 89.8321C158.32 89.8633 157.753 89.4265 157.634 88.792C157.504 88.0951 157.956 87.4294 158.637 87.2942L173.379 84.4598C174.066 84.3297 174.726 84.7822 174.856 85.4791C174.986 86.176 174.534 86.8417 173.852 86.9769L159.11 89.8113C159.053 89.8217 158.996 89.8269 158.939 89.8321Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.537 87.3515L161.267 86.8002L161.039 86.4258L158.371 87.1591L158.537 87.3515Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.766 89.6803L162.262 89.207L162.288 89.6127L159.766 90.0964V89.6803Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.723 87.7825L172.281 87.2832L172.489 87.6368L169.925 88.2297L169.723 87.7825Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.318 85.2026L171.944 84.7345L172.022 84.3965L169.35 84.8125L169.318 85.2026Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.495 83.7677C184.877 83.7989 184.31 83.362 184.19 82.7275C184.06 82.0306 184.513 81.3649 185.194 81.2297L199.936 78.3953C200.622 78.2653 201.283 78.7177 201.413 79.4146C201.543 80.1115 201.09 80.7772 200.409 80.9125L185.667 83.7468C185.61 83.7572 185.553 83.7625 185.495 83.7677Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.094 81.2819L187.819 80.7306L187.595 80.3613L184.928 81.0946L185.094 81.2819Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.322 83.6171L188.813 83.1387L188.844 83.5495L186.322 84.0332V83.6171Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.056 98.0218L95.369 96.42C92.0514 95.6243 89.987 92.2386 90.7722 88.8737C91.1518 87.2407 92.1346 85.8625 93.5438 84.9784C94.9478 84.0995 96.6118 83.8238 98.2186 84.2087L104.906 85.8105C106.513 86.1954 107.875 87.1939 108.743 88.6189C109.612 90.0439 109.882 91.7289 109.497 93.3568C108.827 96.238 106.279 98.1882 103.481 98.1882C103.013 98.1882 102.535 98.131 102.056 98.0218ZM93.2318 89.4614C92.769 91.4533 93.9858 93.4556 95.9514 93.9288L102.639 95.5307C104.604 96.0039 106.58 94.7662 107.043 92.7743C107.506 90.7824 106.289 88.7801 104.323 88.3069L97.6362 86.705C97.3554 86.6374 97.0694 86.6062 96.7938 86.6062C95.135 86.6062 93.627 87.7608 93.2318 89.4666V89.4614Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.251 95.3635C120.87 95.3635 121.416 94.9006 121.499 94.2557C121.593 93.5536 121.109 92.9087 120.418 92.8151L105.556 90.7556C104.865 90.662 104.23 91.1509 104.137 91.8478C104.043 92.5499 104.527 93.1948 105.218 93.2884L120.08 95.3479C120.137 95.3583 120.194 95.3583 120.251 95.3583V95.3635Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.198 92.7789L117.832 92.4565L118.05 92.0977L120.37 92.5501L120.198 92.7789Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.263 95.2385L117.11 94.9473L117.053 95.3737L119.2 95.6286L119.263 95.2385Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.372 93.8777L106.793 93.5137L106.605 93.8777L109.195 94.3354L109.372 93.8777Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.649 91.2809L107.007 90.9481L106.908 90.6152L109.597 90.8961L109.649 91.2809Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.6605 92.0106L69.0669 90.0603C65.7909 89.093 63.9033 85.6033 64.8601 82.28C65.3229 80.673 66.3733 79.3416 67.8241 78.5355C69.2749 77.7294 70.9441 77.5422 72.5301 78.0102L79.1237 79.9605C80.7097 80.4286 82.0201 81.4947 82.8157 82.9665C83.6113 84.4331 83.7933 86.1286 83.3305 87.7408C82.5141 90.5856 79.8725 92.3954 77.0749 92.2498C76.6069 92.2238 76.1337 92.1458 75.6605 92.0054V92.0106ZM67.2833 82.9977C66.7165 84.9636 67.8345 87.0283 69.7741 87.6004L76.3677 89.5507C78.3073 90.1227 80.3405 88.989 80.9073 87.0231C81.4741 85.0572 80.3561 82.9925 78.4165 82.4205L71.8229 80.4702C71.5421 80.387 71.2665 80.3402 70.9857 80.3246C69.3321 80.2362 67.7669 81.3127 67.2833 82.9925V82.9977Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9649 90.2989C94.5837 90.3301 95.1505 89.8932 95.2701 89.2588C95.4001 88.5619 94.9477 87.8962 94.2665 87.761L79.5245 84.9266C78.8381 84.7965 78.1777 85.249 78.0477 85.9459C77.9177 86.6428 78.3701 87.3085 79.0513 87.4437L93.7933 90.2781C93.8505 90.2885 93.9077 90.2937 93.9649 90.2989Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1564 87.7408L91.4316 87.1896L91.6552 86.8203L94.3228 87.5536L94.1564 87.7408Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.132 90.149L90.6412 89.6758L90.6152 90.0866L93.132 90.5651V90.149Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1805 88.2512L80.6221 87.752L80.4141 88.1056L82.9777 88.6985L83.1805 88.2512Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5849 85.6713L80.9589 85.2033L80.8809 84.8652L83.5537 85.2865L83.5849 85.6713Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.0642 83.3148C68.6778 83.4188 69.2862 83.0496 69.4734 82.4307C69.6814 81.7546 69.307 81.0369 68.6414 80.8288L54.3102 76.325C53.6446 76.117 52.9374 76.4914 52.7294 77.1675C52.5214 77.8436 52.8958 78.5613 53.5614 78.7694L67.8926 83.2732C67.9498 83.2888 68.007 83.3044 68.059 83.3148H68.0642Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7399 80.8908L66.0879 80.0327L66.3531 79.6895L68.9271 80.7244L68.7399 80.8908Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.259 83.0698L64.8358 82.3105L64.7578 82.7162L67.2122 83.4807L67.259 83.0698Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.568 134.886H104.802C102.243 134.886 100.174 132.811 100.174 130.258C100.174 127.699 102.249 125.629 104.802 125.629H146.568C149.127 125.629 151.196 127.704 151.196 130.258C151.196 132.816 149.121 134.886 146.568 134.886Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.568 134.886H104.802C102.243 134.886 100.174 132.811 100.174 130.258C100.174 127.699 102.249 125.629 104.802 125.629H146.568C149.127 125.629 151.196 127.704 151.196 130.258C151.196 132.816 149.121 134.886 146.568 134.886Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.743 134.886H106.044C103.486 134.886 101.416 132.811 101.416 130.258C101.416 127.699 103.491 125.629 106.044 125.629H147.743C150.301 125.629 152.371 127.704 152.371 130.258C152.371 132.816 150.296 134.886 147.743 134.886Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9609 178.665C59.9609 178.665 63.4085 172.944 66.4973 174.868C69.5861 176.798 68.9985 182.009 65.8941 182.664C62.7845 183.319 60.4757 181.9 60.4757 181.9L59.9661 178.66L59.9609 178.665Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.9609 178.665C59.9609 178.665 63.4085 172.944 66.4973 174.868C69.5861 176.798 68.9985 182.009 65.8941 182.664C62.7845 183.319 60.4757 181.9 60.4757 181.9L59.9661 178.66L59.9609 178.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.751 194.44C57.751 194.44 66.9342 176.565 56.9138 174.817C46.8934 173.07 47.7462 189.483 51.1678 193.545C54.5946 197.612 57.7458 194.44 57.7458 194.44H57.751Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.751 194.44C57.751 194.44 66.9342 176.565 56.9138 174.817C46.8934 173.07 47.7462 189.483 51.1678 193.545C54.5946 197.612 57.7458 194.44 57.7458 194.44H57.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9013 175.888C51.9013 175.888 53.0817 160.431 46.1033 160.317C39.1249 160.203 34.5489 174.718 49.6601 179.269C49.6601 179.269 51.8337 177.391 51.8961 175.888H51.9013Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.9013 175.888C51.9013 175.888 53.0817 160.431 46.1033 160.317C39.1249 160.203 34.5489 174.718 49.6601 179.269C49.6601 179.269 51.8337 177.391 51.8961 175.888H51.9013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0605 160.457C43.2373 160.686 43.3881 160.936 43.5129 161.196",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1855 162.148C40.6431 162.653 41.1579 163.105 41.7195 163.495",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2695 164.816C39.6803 165.045 40.0911 165.274 40.5071 165.503",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9219 171.135C42.3327 171.364 42.7435 171.592 43.1595 171.821",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6816 172.85C40.1392 172.913 40.6176 172.762 40.9608 172.455",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3184 175.316C41.594 175.051 41.8332 174.75 42.0204 174.422",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5234 177.157C43.6742 176.798 43.8146 176.44 43.9446 176.07",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9746 178.094C45.2398 177.719 45.4634 177.319 45.635 176.893",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3136 179.545C48.064 179.15 47.9808 178.656 48.0848 178.203",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0922 174.062C52.5462 174.328 51.9482 174.473 51.3398 174.489",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.421 171.936C51.9842 172.097 51.5058 172.144 51.043 172.066",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2697 169.522C51.9057 169.439 51.5417 169.351 51.1777 169.268",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0881 169.06C48.7241 168.976 48.3601 168.888 47.9961 168.805",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3813 166.174C48.0745 166.387 47.7677 166.6 47.4609 166.814",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7294 160.588C48.511 160.89 48.2926 161.196 48.0742 161.498",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8917 167.084C51.5641 167.136 51.2417 167.188 50.9141 167.24",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4074 165.207C51.0954 165.254 50.7886 165.306 50.4766 165.353",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3611 163.094C49.9139 163.343 49.4667 163.588 49.0195 163.837",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7598 160.172C45.843 160.604 45.895 161.046 45.9106 161.482",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8145 163.85C44.1733 164.115 44.4957 164.432 44.7713 164.786",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4883 167C43.8835 167.078 44.2839 167.114 44.6843 167.099",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2207 169.726C44.2519 169.788 44.3455 169.742 44.3923 169.695C44.6367 169.445 44.8863 169.201 45.1307 168.951",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3086 172.451C45.605 172.191 45.8754 171.9 46.1146 171.588",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7441 171.717C49.0405 171.457 49.3109 171.166 49.5501 170.854",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1855 174.926C47.3259 174.582 47.5339 174.265 47.7939 174",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3145 174.973C44.4549 174.629 44.6629 174.312 44.9229 174.047",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5298 176.721C49.6182 176.3 49.587 175.852 49.4414 175.441",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2518 163.355C47.075 163.714 46.8982 164.073 46.7266 164.437",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9941 167.344C40.2645 167.687 40.6025 167.983 40.9821 168.202",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0156 170.803C39.3744 170.782 39.7384 170.761 40.0972 170.74",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9785 173.787C56.2489 174.26 56.4101 174.801 56.4361 175.342",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2284 174.428C59.3376 175.052 59.1608 175.718 58.7656 176.206",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6035 175.238C52.8115 175.556 53.0611 175.842 53.3471 176.086",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3398 181.422C48.917 181.51 49.489 181.62 50.0558 181.75",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8301 184.762C48.3085 185.209 49.0677 185.323 49.6553 185.032",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5781 188.754C48.9993 188.541 49.4361 188.349 49.8781 188.188",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2754 192.204C49.6706 191.923 50.0658 191.642 50.461 191.361",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3729 191.168C59.6449 191.105 58.9273 190.939 58.2461 190.674",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8028 189.363C60.4076 189.259 60.0176 189.139 59.6328 189.004",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8688 186.4C61.2604 186.389 60.652 186.374 60.0488 186.363",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3531 184.079C61.8487 184.011 61.3495 183.892 60.8711 183.715",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9551 175.207C61.3087 175.628 61.6103 176.096 61.8391 176.596",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7891 174.375C63.9295 174.801 64.0699 175.223 64.2103 175.649",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9219 174.453C67.6151 174.973 67.3551 175.519 67.1523 176.086",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1646 177.381C68.8838 177.792 68.4054 178.067 67.9062 178.099",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5511 182.593C67.8439 182.416 67.1887 182.031 66.6895 181.506",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5322 183.808C64.4438 183.314 64.3762 182.815 64.3398 182.311",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5651 178.998C63.5911 179.3 63.5911 179.607 63.5547 179.903",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0093 177.844C66.1185 178.307 65.9989 178.816 65.6973 179.186",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2201 179.617C60.8353 179.544 60.4505 179.503 60.0605 179.492",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.959 182.202C58.0162 181.817 58.037 181.427 58.0266 181.037",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1816 177.428C55.5456 177.776 55.8628 178.171 56.128 178.598",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6689 180.293C56.3257 180.761 55.7901 181.083 55.2129 181.172",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9902 183.227C55.167 183.601 55.3906 183.955 55.6506 184.277",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.596 186.883C55.8784 187.195 55.062 187.517 54.334 187.231",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5684 189.739C54.7192 189.541 54.896 189.364 55.0884 189.203",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4707 189.088C57.6215 188.891 57.7983 188.714 57.9907 188.553",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3711 192.235C54.5947 191.86 54.8599 191.512 55.1719 191.205",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.127 179.533C51.4962 179.814 51.8342 180.136 52.1358 180.49",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9336 183.99C51.1416 184.011 51.3496 184.032 51.5576 184.053",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9551 186.867C51.2203 186.914 51.4855 186.961 51.7455 187.013",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7804 184.646C58.6036 184.849 58.4268 185.047 58.25 185.25",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.377 190.08C51.7098 189.981 52.0426 189.883 52.3754 189.789",
    stroke: "#407BFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1501 192.869H45.8965L48.3561 205.611H60.6489L63.1501 192.869Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8934 192.869H44.9082V195.932H63.8934V192.869Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4883 195.932L46.8367 197.741L62.3691 196.837L62.5459 195.932H46.4883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.838 140.29C185.926 141.382 185.23 142.266 184.288 142.266H154.368C153.421 142.266 152.579 141.382 152.496 140.29L150.717 118.265C150.696 118.036 150.717 117.823 150.754 117.62C150.92 116.845 151.513 116.283 152.267 116.283H182.188C183.139 116.283 183.976 117.167 184.06 118.259L185.838 140.285V140.29Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M185.838 140.29C185.926 141.382 185.23 142.266 184.288 142.266H154.368C153.421 142.266 152.579 141.382 152.496 140.29L150.717 118.265C150.696 118.036 150.717 117.823 150.754 117.62C150.92 116.845 151.513 116.283 152.267 116.283H182.188C183.139 116.283 183.976 117.167 184.06 118.259L185.838 140.285V140.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.179 142.265H154.362C153.415 142.265 152.573 141.381 152.49 140.289L150.711 118.264C150.691 118.035 150.711 117.822 150.748 117.619H180.565C181.511 117.619 182.348 118.503 182.437 119.595L184.215 141.62C184.236 141.849 184.215 142.063 184.179 142.265Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M184.179 142.265H154.362C153.415 142.265 152.573 141.381 152.49 140.289L150.711 118.264C150.691 118.035 150.711 117.822 150.748 117.619H180.565C181.511 117.619 182.348 118.503 182.437 119.595L184.215 141.62C184.236 141.849 184.215 142.063 184.179 142.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.117 137.127L170.129 137.158L168.964 147.991L174.876 148.085V149.359L158.959 149.401V148.137L162.797 148.064L164.117 137.127Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.127 137.158C170.112 137.319 171.459 142.265 171.459 142.265H169.576L170.127 137.158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.499 142.265L164.117 137.127L162.562 142.265H163.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.202 149.949H147.133V206.83H149.202V149.949Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.202 149.949H147.133V206.83H149.202V149.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.341 149.949H132.271V206.83H134.341V149.949Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.341 149.949H132.271V206.83H134.341V149.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M132.271 153.548V157.22L134.341 156.3V153.236L132.271 153.548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.133 153.548V157.22L149.202 156.3V153.236L147.133 153.548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.263 149.949H191.193V206.83H193.263V149.949Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M193.263 149.949H191.193V206.83H193.263V149.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.193 153.548V157.22L193.263 156.3V153.236L191.193 153.548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.247 149.949H210.178V206.83H212.247V149.949Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M212.247 149.949H210.178V206.83H212.247V149.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.178 153.513V157.179L212.242 156.259V153.195L210.178 153.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.822 149.34H129.594V153.552H214.822V149.34Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M214.822 149.34H194.828V153.552H214.822V149.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M164.117 137.127L170.129 137.158L168.964 147.991L174.876 148.085V149.359L158.959 149.401V148.137L162.797 148.064L164.117 137.127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1512_8793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 210,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopUser);
export default __webpack_public_path__ + "static/media/stopUser.b11ba8431ac5aeb3394f8320810f5a07.svg";
export { ForwardRef as ReactComponent };